import SvgTelegram from "@/assets/icons/telegram.svg";
import SvgWhatsapp from "@/assets/icons/whatsapp.svg";
import SvgSkype from "@/assets/icons/skype.svg";
import SvgWeChat from "@/assets/icons/wechat.svg";
import SvgMicrosoftTeams from "@/assets/icons/microsoft-teams.svg";

export enum MESSENGER {
    TELEGRAM = 'telegram',
    SKYPE = 'skype',
    WHATSAPP = 'whatsapp',
    WECHAT = 'wechat',
    TEAMS = 'teams',
}

export const MESSENGER_ICONS = {
    [MESSENGER.TELEGRAM]: SvgTelegram,
    [MESSENGER.SKYPE]: SvgSkype,
    [MESSENGER.WHATSAPP]: SvgWhatsapp,
    [MESSENGER.WECHAT]: SvgWeChat,
};

export interface IMessengerItem {
    type: MESSENGER;
    logo: SVGElement;
}

export const messengerItems: IMessengerItem[] = [
    { type: MESSENGER.TELEGRAM, logo: SvgTelegram },
    { type: MESSENGER.WHATSAPP, logo: SvgWhatsapp },
    { type: MESSENGER.TEAMS, logo: SvgMicrosoftTeams },
    { type: MESSENGER.WECHAT, logo: SvgWeChat },
];
